<script>
export default {
	name: "VNode",
	props: ['node'],
	render() {
		return this.node || null
	}
}
</script>
